import { Head, Banner, Contact } from "../components/Project";
import { Grid, Space, Table, QA } from "../components/Layout";
import { Title, Texts, Media } from "../components/Object";
import { ContactButton } from "../components/Project/Contact";
import { List as PointList } from "../components/Project/Choose";
import { useRef, useEffect } from "react";
import { useDocumentLoadCompleted,useToggle, useOffsetTop } from "../components/Hooks";

const Service = () => {
  
   const Message = () => {
    const gridProps = {
      about: {
        dir: ["column", "row"],
        gap: ["80px", "40px"],
        class: "",
        layout: ["510px 1fr", "100%"],
      },
      inner: {
        dir: ["row"],
        gap: 0,
        class: "",
        layout: ["100%"],
      },
    };
    return (
      <>
        <div className="l-row">
          <Space size={["160px auto 120px", "80px auto 72px"]}>
            <Grid {...gridProps.about}>
              <Grid {...gridProps.inner}>
                <Space size={["56px 0 72px", "0px 0 32px"]}>
                  <Texts slug="service-page/title"></Texts>
                </Space>
                <Space size={["0 0 64px", "0 0 48px"]}>
                  <Texts slug="service-page/body" />
                </Space>

                {/* <Button slug="service" link="/service/" /> */}
              </Grid>

              <Media src="recruit/about" alt="media" class=""></Media>
            </Grid>
          </Space>
        </div>
      </>
    );
  };

  const BoxList = (props) => {
    const Item = (props) => {
      return (
        <>
          <div className="p-service__wrap--bar">
            <Texts slug={`${props.slug}/title${props.index}`}></Texts>
            <Space size={["32px auto 0", "24px 0 0"]}>
              <Texts slug={`${props.slug}/body${props.index}`}></Texts>
            </Space>
            <Space size={["40px auto 0", "32px 0 0"]}>
              <Media
                alt="サービス　イメージ"
                src={`${props.slug}/list${props.index}`}
              ></Media>
            </Space>
          </div>
        </>
      );
    };

    let items = [];
    for (let i = 0; i < props.length; i++) {
      items.push(<Item key={i} index={i} slug={props.slug}></Item>);
    }

    const gridProps = {
      list: {
        dir: ["row"],
        layout: ["100%"],
        gap: ["40px", "32px"],
        size: "100%",
      },
    };

    return (
      <>
        <div className="p-box__wrap" id={`item${props.index}`}>
          <Media
            src={`box-back/${props.slug}`}
            alt="background"
            class="p-box__img--back"
          ></Media>
          <div className="p-box__wrap--white l-row">
            <div className="p-box__wrap--white__inner p-box__wrap--white__inner">
              <div className="p-title__wrap--section">
                <Texts class="c-text--med" slug={`${props.slug}/title`}></Texts>
              </div>
              <Space size={["80px 0 0", "64px 0 0"]}>
                <Grid {...gridProps.list}>{items}</Grid>
              </Space>
            </div>
          </div>
        </div>
      </>
    );
  };

  const QAList = () => {
    return (
      <>
        <div
          id="qa"
          className="l-row"
          data-state="min"
        >
          <Space size={["120px 0 120px", "80px 0 80px"]}>
            <Title slug="faq"></Title>
            <Space size={["80px 0 0", "64px 0 0"]}>
              <QA length="9" slug="faq"></QA>
            </Space>
          </Space>
        </div>
      </>
    );
  };

  const gridProps = {
    box: {
      gap: ["120px", "80px"],
      layout: ["100%"],
      size: ["100%"],
      dir: ["row"],
    },
  };

  return (
    <>
      <Head slug="service-page"></Head>

      <Message></Message>

      <Grid {...gridProps.box}>
        <BoxList length="3" index='0' slug="house"></BoxList>
        <BoxList length="3" index='1' slug="bill"></BoxList>
        <BoxList length="3" index='2' slug="new"></BoxList>
      </Grid>

      <QAList></QAList>

      <Banner></Banner>
      <Contact></Contact>
    </>
  );
};

export default Service;
